import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n\n  > div:last-child {\n    width: 100%;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import useHandoutProductStore from "src/store/relatedProduct";
import { createStore, useStore } from "zustand";
import { getLegacyProduct, getProduct } from "../../api/product";
import { checkFreeTrial } from "../Product/hooks/useFreeTrialCheck";
import { PreviewBookModal } from "../Landing/modals/PreviewBookModal";
import Modal from "../modal/Modal";
const PreviewDialogContext = /*#__PURE__*/ createContext(null);
export const PreviewDialogProvider = (param)=>{
    let { children  } = param;
    const storeRef = useRef();
    const router = useRouter();
    // const [productDetail, setProductDetail] = useState<IProduct | null>(null)
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const { currentProduct , updateCurrentProduct , setFreeTrialData  } = useHandoutProductStore((state)=>({
            updateCurrentProduct: state.updateCurrentProduct,
            currentProduct: state.currentProduct,
            setFreeTrialData: state.setFreeTrialData
        }));
    const getProductLegacyMutation = useMutation(getLegacyProduct);
    const getProductMutation = useMutation(getProduct);
    const openPreviewDialog = async (param)=>{
        let { id  } = param;
        try {
            // 무료체험 데이터 로딩 시작
            setFreeTrialData(null, true);
            const response = await getProductLegacyMutation.mutateAsync({
                id
            });
            const newProductResponse = await getProductMutation.mutateAsync({
                id
            });
            updateCurrentProduct({
                ...response.product,
                purchaseOptions: newProductResponse.purchaseOptions,
                downloadPrice: newProductResponse.downloadPrice,
                type: newProductResponse.type
            });
            // 무료체험 데이터 가져오기
            try {
                const freeTrialResponse = await checkFreeTrial({
                    productId: id
                });
                setFreeTrialData(freeTrialResponse, false);
            } catch (e) {
                // 무료체험 데이터 가져오기 실패해도 모달은 열림
                setFreeTrialData(null, false);
            }
            setPreviewModalOpen(true);
        } catch (e) {
            setFreeTrialData(null, false);
            window.alert("교재 정보를 불러오는데 실패했습니다.");
        }
    };
    const closePreviewDialog = ()=>{
        setPreviewModalOpen(false);
        updateCurrentProduct(null);
        setFreeTrialData(null, false);
    };
    if (!storeRef.current) {
        storeRef.current = createStore((set)=>({
                openPreviewDialog,
                closePreviewDialog
            }));
    }
    useEffect(()=>{
        //페이지 이동시 닫혀야함.
        closePreviewDialog();
    }, [
        router
    ]);
    return /*#__PURE__*/ _jsxs(PreviewDialogContext.Provider, {
        value: storeRef.current,
        children: [
            children,
            currentProduct && /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx(StyledModal, {
                    modalBgColor: "transparent",
                    disableOutsideClick: false,
                    onClose: closePreviewDialog,
                    open: previewModalOpen,
                    name: "mainPreviewModal",
                    children: /*#__PURE__*/ _jsx(PreviewBookModal, {
                        onClose: closePreviewDialog
                    })
                })
            })
        ]
    });
};
const StyledModal = styled(Modal)(_templateObject());
export const usePreviewDialogStore = ()=>{
    const store = useContext(PreviewDialogContext);
    if (!store) {
        throw new Error("Missing PreviewDialogProvider");
    }
    return useStore(store);
};
